import { render, staticRenderFns } from "./InfoGraphic.vue?vue&type=template&id=1fce50f6&"
import script from "./InfoGraphic.vue?vue&type=script&lang=js&"
export * from "./InfoGraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports